import React from 'react';
import { Button, Col, Row } from "react-bootstrap";
import FieldGroup from "../../../../components/FieldGroup";

const PartnerDomainsFilters = ({ onApply, state, handleFieldChange }) => {
    return (
        <Row style={{ marginBottom: '15px' }}>
            <Col lg={3}>
                <FieldGroup
                    type="date"
                    name="date_from"
                    label="Date From:"
                    onChange={handleFieldChange}
                    value={state.dateFrom}
                />
            </Col>
            <Col lg={3}>
                <FieldGroup
                    type="date"
                    name="date_to"
                    label="Date To:"
                    onChange={handleFieldChange}
                    value={state.dateTo}
                />
            </Col>

            <Col lg={12}><Button onClick={onApply} bsStyle={"primary"}>Apply</Button></Col>
        </Row>
    );
};

export default PartnerDomainsFilters;


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/components/PartnerDomainsFilters/PartnerDomainsFilters.js